import _extends from 'babel-runtime/helpers/extends';

import { grantRechargeRefund } from '@/api/grant/grant';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    id: {
      type: Number,
      required: true,
      default: 0
    },
    money: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data: function data() {
    return {
      loading: false,
      formValue: {
        id: 0,
        reason: '',
        money: undefined
      },
      rules: {
        reason: [{ required: true, trigger: 'blur', message: '请输入退款原因' }],
        money: [{ required: true, trigger: 'blur', message: '请输入退款金额' }]
      },
      // 广告主数据
      advertiserList: []
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },
    dialogAttrs: function dialogAttrs() {
      return _extends({
        title: '退款'
      }, this.$attrs);
    }
  },
  watch: {
    dialogVisible: function dialogVisible() {
      var _this = this;

      this.formValue.reason = '';
      this.formValue.money = undefined;
      this.$nextTick(function () {
        _this.$refs.form.clearValidate();
      });
    }
  },
  mounted: function mounted() {},

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('update:visible', false);
    },
    submit: function submit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          grantRechargeRefund(_extends({}, _this2.formValue, { id: _this2.id })).then(function () {
            _this2.closeDialog();
            _this2.$emit('save-success');
          }).finally(function () {
            _this2.loading = false;
          });
        }
      });
    }
  }
};